// Module
var code = "<div class=\"\" ng-controller=\"LogincallbackCtrl\"> </div> ";
// Exports
export default code;